import { Injectable } from '@angular/core';

export type BackButtonHandler = () => boolean;

/**
 * Minimal override seam for the hardware/browser back button.
 *
 * Pure Angular (no Capacitor): the native `App.backButton` listener stays in
 * apps/mobile's AppComponent and consults this registry; shared flows in
 * libs register a handler here without ever importing from an app. Web apps
 * never call `handle()`, so registering there is a harmless no-op.
 * A single active screen (e.g. a quoter step) can register a handler while
 * mounted; `AppComponent`'s global backButton listener consults it first and
 * only falls back to the default navigation when it is unset or declines
 * the event (returns false).
 */
@Injectable({ providedIn: 'root' })
export class BackButtonOverrideService {
  private handler: BackButtonHandler | null = null;

  register(handler: BackButtonHandler): void {
    this.handler = handler;
  }

  unregister(handler: BackButtonHandler): void {
    if (this.handler === handler) {
      this.handler = null;
    }
  }

  /** Returns true when the event was handled by the registered override. */
  handle(): boolean {
    return this.handler ? this.handler() : false;
  }
}
